<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options"/>
  </div>
</template>

<script>
const TableName = 'VUETABLE_TAGSALES';
export default {
    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: [
                'name',
                'parent',
                'product_name',
                'product_quantity',
                'total_net_sales',
            ],
            options: {
                texts: {
                    title: 'Product Sales by Tag',
                    description: 'Shows product sales by tag',
                },
                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                headings: {
                    name: 'Tag',
                    product_quantity: 'Total product quantity',
                    total_net_sales: 'Total net sales',
                },
                templates: {
                    parent(h, row) {
                        return require('./parent.jsx')(h, row);
                    },
                    total_net_sales: (h, row) => {
                        return numeral(
                            parseFloat(row.total_net_sales),
                        ).format();
                    },
                },
                pdf_url: Laroute.route(
                    'franchise.report.item.exportTagSalesAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.item.exportTagSalesAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.item.exportTagSalesAsFile',
                    { type: 'XLSX' },
                ),
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.item.getTagSales');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/vuetable_tag_sales.vue